import { useEffect } from "react";
import { logger } from "@/utils/logger";

/**
 * Componente que exibe uma mensagem clara quando o frontend está totalmente inicializado
 */
const StartupMessage = () => {
  useEffect(() => {
    // Mensagem de inicialização
    const message = `
==========================================================
    FRONTEND APPLICATION STARTED SUCCESSFULLY!
    Frontend is now running on port: ${window.location.port || "3000"}
    Access the application at: ${window.location.origin}
==========================================================
`;

    // Exibe no console
    logger.info(message);

    // Registra no logger da aplicação
    logger.info("Frontend application started successfully");
  }, []);

  // Este componente não renderiza nada visualmente
  return null;
};

export default StartupMessage;
